document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sapientino-landing__scrolling-carousel').forEach(scrollingCarousel => {
    const scrollingCarouselSwiper = new Swiper(scrollingCarousel, {
      slidesPerView: "auto",
      allowSlidePrev: false,
      allowTouchMove: false,
      speed: 5000,
      freeMode: true,
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      }
    });
  });

  document.querySelectorAll('.sapientino-landing__video-carousel').forEach(videoCarousel => {
    const videoCarouselSwiper = new Swiper(videoCarousel, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      centeredSlides: true,
      speed: 300,
      autoHeight: true,

      navigation: {
        prevEl: '.sapientino-landing__video-carousel__arrow.left',
        nextEl: '.sapientino-landing__video-carousel__arrow.right',
      },

      breakpoints: {
        768: {
          slidesPerView: "auto",
          spaceBetween: 16
        }
      }
    });

    videoCarouselSwiper.on('slideChange', function (e) {
      videoCarouselSwiper.slides.forEach(slide => {
        const video = slide.querySelector('video');
        if (video && !video.paused) {
          video.pause();
        }
      });
    });

    const popupContainer = videoCarousel.querySelector('.sapientino-landing__video-carousel__popup-container');
    if (popupContainer) {
      popupContainer.addEventListener('click', e => {
        if (e.target.classList.contains('sapientino-landing__video-carousel__popup-container')) {
          popupContainer.querySelectorAll('[data-video-index]').forEach(video => {
            video.classList.remove('show');
            video.querySelector('video').pause();
          });
          popupContainer.classList.remove('open');
          document.querySelector('html').style.overflow = '';
        }
      });

      document.querySelectorAll('.swiper-slide figure[data-popup-opener]').forEach(figure => {
        figure.addEventListener('click', () => {
          if (window.innerWidth < 768) return;
          const videoIndex = figure.dataset.popupOpener;
          const video = popupContainer.querySelector('[data-video-index="' + videoIndex + '"]');
          if (video) {
            popupContainer.classList.add('open');
            video.classList.add('show');
            document.querySelector('html').style.overflow = 'hidden';
            video.querySelector('video').play();
          }
        });
      });
    }
  });
});
